import { Controller } from "@hotwired/stimulus"

// Sonioxのステータスを手動で確認するコントローラー
// ボタンをクリック → Rails経由でRSSフィードを取得 → ポップアップ表示
export default class extends Controller {
  static targets = ["button", "popup", "statusIcon", "statusText", "incidentDetail"]

  connect() {
    this.isOpen = false
    // ポップアップ外クリックで閉じる
    this._boundClose = this.closeOnOutsideClick.bind(this)
  }

  disconnect() {
    document.removeEventListener("click", this._boundClose)
  }

  async check(event) {
    event.stopPropagation()

    if (this.isOpen) {
      this.close()
      return
    }

    this.showLoading()
    this.open()

    try {
      const response = await fetch("/api/soniox_status", {
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        }
      })
      const data = await response.json()
      this.renderResult(data)
    } catch (e) {
      this.renderError()
    }
  }

  open() {
    this.isOpen = true
    this.popupTarget.classList.remove("hidden")
    // 次のtickで外側クリック検知を登録（即時登録すると今のclickで閉じてしまう）
    setTimeout(() => {
      document.addEventListener("click", this._boundClose)
    }, 0)
  }

  close() {
    this.isOpen = false
    this.popupTarget.classList.add("hidden")
    document.removeEventListener("click", this._boundClose)
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  showLoading() {
    this.statusIconTarget.textContent = "⏳"
    this.statusTextTarget.textContent = "確認中..."
    this.statusTextTarget.className = "text-sm font-semibold text-gray-500"
    this.incidentDetailTarget.classList.add("hidden")
  }

  renderResult(data) {
    if (data.error) {
      this.renderError()
      return
    }

    if (data.ok) {
      this.statusIconTarget.textContent = "✅"
      this.statusTextTarget.textContent = "正常稼働中"
      this.statusTextTarget.className = "text-sm font-semibold text-green-600"
      this.incidentDetailTarget.classList.add("hidden")
    } else {
      this.statusIconTarget.textContent = "⚠️"
      this.statusTextTarget.textContent = "障害の可能性あり"
      this.statusTextTarget.className = "text-sm font-semibold text-red-600"

      if (data.latest_incident) {
        const inc = data.latest_incident
        const date = inc.published_at ? new Date(inc.published_at).toLocaleString("ja-JP") : ""
        this.incidentDetailTarget.innerHTML = `
          <div class="mt-2 pt-2 border-t border-gray-200">
            <p class="text-xs font-semibold text-gray-700 mb-1">${inc.title}</p>
            <p class="text-xs text-gray-500 mb-2">${date}</p>
            <a href="${inc.link}" target="_blank" rel="noopener noreferrer"
               class="text-xs text-blue-500 hover:underline">詳細を確認 →</a>
          </div>
        `
        this.incidentDetailTarget.classList.remove("hidden")
      }
    }
  }

  renderError() {
    this.statusIconTarget.textContent = "❓"
    this.statusTextTarget.textContent = "取得できませんでした"
    this.statusTextTarget.className = "text-sm font-semibold text-gray-500"
    this.incidentDetailTarget.classList.add("hidden")
  }
}
